<template>
  <div>
    <slot></slot>
  </div>
</template>
<script type="text/babel">
  export default {
    loadmore: 'loadmore',
    props: {
      bottomMethod: {
        type: Function
      },
    },

    data() {
      return {
         trigger:false,
         scrollEventTarget:null
      };
    },
    computed: {

    },

    watch: {

    },

    methods: {
      getScrollEventTarget(element) {
        let currentNode = element;
        while (currentNode && currentNode.tagName !== 'HTML' &&
          currentNode.tagName !== 'BODY' && currentNode.nodeType === 1) {
          let overflowY = document.defaultView.getComputedStyle(currentNode).overflowY;
          if (overflowY === 'scroll' || overflowY === 'auto') {
            return currentNode;
          }
          if(currentNode.parentNode.id=='app'&&overflowY != 'hidden'){
            currentNode.style.height="100%"
            currentNode.style.overflowY="auto"
            return currentNode;
          }

          currentNode = currentNode.parentNode;
        }
        return window;
      },
      onBottomLoaded(){
        this.trigger = false
      },
      watchScroll(){
         let {scrollTop,clientHeight,scrollHeight} = this.scrollEventTarget
         if(scrollTop + clientHeight >= scrollHeight - 10){
              if(!this.trigger){
                this.trigger = true
                this.bottomMethod()
              }
          }
      },
      init() {
        if(!this.scrollEventTarget){
          this.scrollEventTarget = this.getScrollEventTarget(this.$el); 
        }  
        this.scrollEventTarget.addEventListener('scroll',this.watchScroll)   
      },
    },
    beforeDestroy(){
         this.scrollEventTarget.removeEventListener('scroll',this.watchScroll)   
    },
    mounted() {
      this.init();
    },
  };
</script>


// WEBPACK FOOTER //
// src/components/loadmore.vue